export default __webpack_public_path__ + "static/media/more-alt.dc11eb4c.svg";